import React from 'react';
import { Card, Row, Col, Form, Switch } from 'antd';
import { CompanySettings } from '../../../../types/company.types';

interface NotificationSettingsFormProps {
  form: ReturnType<typeof Form.useForm>[0];
  settings: CompanySettings;
  loading: boolean;
}

const NotificationSettingsForm: React.FC<NotificationSettingsFormProps> = ({ form, settings, loading }) => (
  <Card className="setting-card" title="Bildirim Ayarları">
    <Row gutter={[24, 16]}>
      <Col xs={24} sm={12} md={8}>
        <Form.Item
          label="İzin Bildirimleri"
          name="sendNotifLeave"
          valuePropName="checked"
          initialValue={settings.sendNotifLeave}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Form.Item
          label="Talep Bildirimleri"
          name="sendNotifTicket"
          valuePropName="checked"
          initialValue={settings.sendNotifTicket}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Form.Item
          label="Mazeret Bildirimleri"
          name="sendNotifExcuse"
          valuePropName="checked"
          initialValue={settings.sendNotifExcuse}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Form.Item
          label="Mola Bildirimleri"
          name="sendNotifBreak"
          valuePropName="checked"
          initialValue={settings.sendNotifBreak}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
    </Row>
  </Card>
);

export default NotificationSettingsForm;
